import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import './ourwork.css';


import Partitionimg1 from '../../assets/dsl 041.jpg';
import Partitionimg4 from '../../assets/dsl 077.jpg';
import Partitionimg5 from '../../assets/dsl 084.jpg';
import Partitionimg6 from '../../assets/Hela - 007.jpg';
import Partitionimg2 from '../../assets/dsl 049.jpg';
import Partitionimg3 from '../../assets/dsl 074.jpg';

import Partitionimg7 from '../../assets/partition1.jpg';
import Partitionimg8 from '../../assets/partition2.jpg';
import Partitionimg9 from '../../assets/partition3.JPG';
import Partitionimg10 from '../../assets/partition4.JPG';
import Partitionimg11 from '../../assets/partition5.JPG';
import Partitionimg12 from '../../assets/partition6.jpg';



import Windowimg1 from '../../assets/window1.JPG';
import Windowimg2 from '../../assets/window2.JPG';
import Windowimg3 from '../../assets/window3.JPG';
import Windowimg4 from '../../assets/window4.JPG';
import Windowimg5 from '../../assets/window5.JPG';
import Windowimg6 from '../../assets/window6.JPG';



import Roofimg3 from '../../assets/roof3.JPG';
import Roofimg4 from '../../assets/roof4.JPG';
import Roofimg1 from '../../assets/roof1.png';
import Roofimg2 from '../../assets/roof2.png';
import Roofimg5 from '../../assets/roof5.JPG';



const sections = [
  {
    title: 'Partitions',
    images: [Partitionimg1, Partitionimg2, Partitionimg3, Partitionimg4, Partitionimg5, Partitionimg6, Partitionimg7, Partitionimg8, Partitionimg9, Partitionimg10, Partitionimg11, Partitionimg12]
  },

    {
    title: 'Aluminium Windows',
    images: [Windowimg1, Windowimg2, Windowimg3, Windowimg4, Windowimg5, Windowimg6]
  },   {
    title: 'Polycarbonate Sheet Roofs & Canopies Ceilings',
    images: [ Roofimg3, Roofimg4, Roofimg1, Roofimg2, Roofimg5]
  }
// Roofimg1,

];

const OurWork = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
      <h1 align="center">Highlighting on-site results</h1>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};

export default OurWork;
